export const BASKET_T = { it: { tab: "Cestino" }, en: { tab: "Basket" }, es: { tab: "Cesta" }, pt: { tab: "Cesta" } };
